<template>
	<div style="width: 100%">
		<v-row no-gutters class="mb-n8">
			<v-progress-linear
				class="mb-4"
				v-if="loadingTariffs"
				indeterminate
				color="#F9A825"
				height="7"
				absolute
			></v-progress-linear>
		</v-row>
		<v-row class="d-flex mt-5" justify="center">
			<v-col cols="12" align="center">
				<ConfiguratorNav />
			</v-col>
		</v-row>

		<v-row no-gutters>
			<v-col cols="12" md="2" class="pa-md-2 pr-md-1">
				<ConfiguratorAside />
			</v-col>
			<v-col cols="12" md="10" class="pa-md-2 pl-md-1">
				<ConfiguratorContainer />
			</v-col>
		</v-row>
		<div
			class="d-flex flex-rows"
			style="position: fixed; left: 10px; bottom: 20px"
		>
				<v-btn
					class="mr-2"
					:x-large="$vuetify.breakpoint.smAndUp"
					fab
					dark
					color="primary"
					@click="$router.back()"
				>
					<v-icon size="34px">mdi-arrow-left</v-icon>
				</v-btn>
		</div>
		<div
			class="d-flex flex-rows"
			style="position: fixed; right: 10px; bottom: 20px"
		>
			<v-btn
				class="mr-2"
				:x-large="$vuetify.breakpoint.smAndUp"
				fab
				dark
				color="red darken-3"
				@click="reset()"
			>
				<v-icon size="34px">mdi-delete-outline</v-icon>
			</v-btn>
			<v-btn
				class="mr-2"
				:x-large="$vuetify.breakpoint.smAndUp"
				fab
				dark
				color="purple"
				@click="openPresetDialog"
			>
				<v-icon size="34px">mdi-cursor-default-click-outline</v-icon>
			</v-btn>
			<RenuevoView
				v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
				:info="{
					documentType:
						cliente && cliente.tipoDocumento
							? cliente.tipoDocumento
							: null,
					document:
						cliente && cliente.documento ? cliente.documento : null,
					contactNumbers:
						cliente && cliente.telefonosContacto
							? cliente.telefonosContacto
							: [],
				}"
			/>
			<v-btn
				class="ml-2"
				:x-large="$vuetify.breakpoint.smAndUp"
				fab
				v-if="configuratorType == 'CREATE'"
				color="success"
				@click="submitOffer"
				:disabled="!isEnabledSaving"
			>
				<v-icon size="34px">mdi-content-save</v-icon>
			</v-btn>
			<v-btn
				class="ml-2"
				:x-large="$vuetify.breakpoint.smAndUp"
				fab
				v-else
				color="warning"
				@click="saveEditedOffer"
				:disabled="!isEnabledSaving"
			>
				<v-icon size="34px">mdi-pen</v-icon>
			</v-btn>
		</div>
	</div>
</template>

<script>
import ConfiguratorAside from '@/components/ComercialTeletrabajo/OfferConfigurator/ConfiguratorAside.vue';
import ConfiguratorNav from '@/components/ComercialTeletrabajo/OfferConfigurator/ConfiguratorNav.vue';
import ConfiguratorContainer from '@/components/ComercialTeletrabajo/OfferConfigurator/ConfiguratorContainer.vue';
import RenuevoView from '@/components/ComercialTeletrabajo/DetailedView/RenuevoView.vue';

import defaultPaqueteForm from '@/util/offerConfigurator/defaultPaqueteForm.js';
import { mapGetters, mapState } from 'vuex';

export default {
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	data: () => ({}),
	name: 'Configurator',
	components: {
		ConfiguratorAside,
		ConfiguratorNav,
		ConfiguratorContainer,
		RenuevoView,
	},
	mounted() {
		this.reset();
		this.$store.dispatch('configuradorOferta/getCliente', this.id);
	},
	beforeCreate() {
		if (!this.tariffs || this.tariffs.length == 0) {
			this.$store.dispatch('configuradorOferta/init');
		}
	},
	methods: {
		async reset() {
			await this.$store.dispatch('configuradorOferta/reset');
			this.autoFillComercial();
			this.$store.commit('configuradorOferta/presetPhoneNumbers', []);
			// this.$store.dispatch('configuradorOferta/getCliente', this.id);
		},
		openPresetDialog() {
			this.$store.commit('configuradorOferta/isOpenPresetDialog', true);
		},
		preventNav(event) {
			if (this.configuratorType == 'EDIT') {
				event.preventDefault();
				event.returnValue = '';
			}
		},
		submitOffer() {
			this.$store.dispatch('configuradorOferta/guardarOferta');
		},
		saveEditedOffer() {
			window.removeEventListener('beforeunload', this.preventNav);
			this.$store.dispatch('configuradorOferta/saveEditedOffer');
		},
		autoFillComercial() {
			if (
				this.comerciales.map(({ id }) => id).includes(this.comercialId)
			) {
				this.$store.commit(
					'configuradorOferta/comercial',
					this.comerciales.find(({ id }) => id == this.comercialId)
				);
			}
		},
	},
	computed: {
		loadingTariffs() {
			return this.$store.state.configuradorOferta.loadingTariffs;
		},
		isEnabledSaving() {
			return (
				((this.paquetesSVA.length > 0 &&
					this.mainLine.lineasAsociadas.length > 0) ||
					this.additionalPackages.length > 0 ||
					this.mainLine.tarifa) &&
				this.canSaveOffer
			);
		},
		...mapGetters('configuradorOferta', {
			selectedSVAs: 'selectedSVAs',
			mainLine: 'mainLine',
			additionalPackages: 'additionalPackages',
		}),
		...mapState('configuradorOferta', {
			cliente: (state) => state.cliente,
			paquetesSVA: (state) =>
				state.atencion.oferta.paquetes.filter(
					(paquete) => paquete.tipoLinea == 'LINEA_ADICIONAL_SVA'
				),
			configuratorType: (state) => state.configuratorType,
			canSaveOffer: (state) => state.canSaveOffer,
		}),
		...mapState('login', {
			comercialId: (state) => state.id,
		}),
		...mapGetters('teletrabajo', {
			comerciales: 'allComerciales',
		}),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			ckeckGroupPermission: 'ckeckGroupPermission',
		}),
	},
	beforeMount() {
		window.addEventListener('beforeunload', this.preventNav);
		this.$once('hook:beforeDestroy', () => {
			window.removeEventListener('beforeunload', this.preventNav);
		});
	},

	beforeRouteLeave(to, from, next) {
		if (this.configuratorType == 'EDIT' && to.name == 'OfferConfigurator')
			if (!window.confirm('Leave without saving?')) return;

		next();
	},
	// watch : {
	//     configuratorType(){
	//         if (this.configuratorType=='EDIT') window.addEventListener("beforeunload", this.preventNav)
	//     }
	// },
};
</script>

<style>
#control-height {
	height: 100vh;
	width: 0;
	position: fixed;
}
</style>